module.exports = __webpack_public_path__ + "img/d2646cd5b9dd4dc9bb7ab2d3b4bbf0d7.6c827df1.jpg";